import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Footer {
  protected readonly privacyUrl = 'https://sparecores.com/legal/privacy-policy';
  protected readonly termsUrl = 'https://sparecores.com/legal/terms-of-service';
  protected readonly contactEmail = 'mailto:support@sparecores.com';
}
